import React from "react";

import AppWrapper from "../../components/cm/AppWrapper";
import SideBarMain from "../../components/cm/SideBarMain";
import { MainNavBarEnum } from "../../components/cm/SideBarMain/MainNavBarEnum";
import ProviderMapPageWrapper from "../../components/modules/providers/search-provider/components/wrappers/ProviderMapPageWrapper";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain activeRoute={MainNavBarEnum.PROVIDER_MAP} />}>
      <ProviderMapPageWrapper />
    </AppWrapper.WithSidebar>
  );
};
